import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(
  {
    display: 'flex',
    padding: '0.5rem 1.5rem'
  }
);

export const HighlightedBar = styled(Box)(
  ({ theme }) => ({
    minWidth: '0.25rem',
    minHeight: '100%',
    marginRight: '1rem',
    backgroundColor: theme.palette.growthBrand.main
  })
);
